import React from 'react';
import AnimationRevealPage from 'helpers/AnimationRevealPage.js';
import Carrito from 'components/Cart/newCart/CartPage';
import { Container, ContentWithPaddingXl } from 'components/misc/Layouts';

export default () => {
	return (
		<AnimationRevealPage>
			<Container>
				<ContentWithPaddingXl>
					<Carrito />
				</ContentWithPaddingXl>
			</Container>
		</AnimationRevealPage>
	);
};
